<template>
  <http-delete-button
    v-bind="$props"
    v-on="$listeners"
    :href="`/api/savedreports/${(value || {}).id}`"
    version="v2"
    @http4xx="onError"
  >
  </http-delete-button>
</template>

<i18n>
{
    "en": {
        "deleteReportButton.errorMessage": "There was an error encountered while deleting this report. If everything looks right please contact support so we can help you :)"
    }
}
</i18n>

<script>
import { toastError } from "@/components/Common/Toast.vue";
import HttpDeleteButton from "@/components/Common/HttpDeleteButton.vue";

export default {
  props: {
    ...HttpDeleteButton.props,
    value: {
      type: Object,
    },
  },
  methods: {
    onError() {
      toastError(this.$t("deleteReportButton.errorMessage"));
    },
  },
};
</script>